import { Box, Stack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { CountryAdminCountrySelection } from '$/pages/AdminPages/components/CountryAdminCountrySelection';
import { CountryAdminLanguageCard } from '$/pages/AdminPages/pages/LanguagesPage/components/CountryAdminLanguageCard';
import { useCountryAdminStore } from '$/pages/AdminPages/stores/useCountryAdminStore';
import { brandCountriesQuery } from '$/services/usecases/admin/brandCountries';
import { adminLanguagesQuery } from '$/services/usecases/admin/languages';

export const CountryAdminLanguageList = () => {
  const languages = useQuery(adminLanguagesQuery);
  const countries = useQuery(brandCountriesQuery);
  const countryOptions = useCountryAdminStore.useCountryOptions();
  const selectedCountry = useCountryAdminStore.useSelectedCountry();
  const setSelectedCountry = (country: string) =>
    useCountryAdminStore.setState({
      selectedCountry: country,
    });

  const countryToUpdate = countries?.data?.response.payload.find(
    (country) => country.id === selectedCountry,
  );

  if (!languages.data?.response?.payload || !countryToUpdate) {
    return null;
  }

  return (
    <>
      <CountryAdminCountrySelection
        countryOptions={countryOptions}
        onChangeCountry={setSelectedCountry}
        selectedCountry={selectedCountry}
      />
      <Box overflowX='auto'>
        <Stack gap='4' minW='800px'>
          {languages.data.response.payload.map((language) => (
            <CountryAdminLanguageCard
              key={language.id}
              language={language}
              countryToUpdate={countryToUpdate}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};
